<template>

  <div class="row">
	 
    <div class="col-xl-12">
      <h4 class="title">Compliance</h4>
      <p class="category">
      List of compliance submissions.
      </p>
    </div>
    
    
    
        <div class="card">
   		
          <div class="card-body table-responsive table-full-width">
          	
				<el-table :data="controllers"">
					<el-table-column sortable label="Company Name" property="entity.entity_name" min-width=140>
						<template slot-scope="scope">
							{{scope.row.entity.entity_name}}
						</template>
					</el-table-column>
					<el-table-column label="UEN" property="entity_name" min-width=140>
						<template slot-scope="scope">
							{{scope.row.entity.uen}}
						</template>
					</el-table-column>
					<el-table-column label="Controller" min-width=180>
						<template slot-scope="scope">
							
							<div v-if="scope.row.entity.company_type!=7">
								<span v-if="scope.row.shareholder.is_company==2"> 
									 {{scope.row.shareholder.person.first_name}}  {{scope.row.shareholder.person.last_name}}
									 
									 <br/>
									 <span style="font-size:12px;text-transform:lowercase;color:#666">{{scope.row.shareholder.person.email}}</span> 
								</span>	 
								<span v-if="scope.row.shareholder.is_company==1"> 
							 		{{scope.row.shareholder.shareholder_company.company_name}}  ({{scope.row.shareholder.shareholder_company.company_reg_num}})
								</span>
								
							</div>
							
							<div v-if="scope.row.entity.company_type==7">
								<span v-if="scope.row.member.is_company==2"> 
									 {{scope.row.member.person.first_name}}  {{scope.row.member.person.last_name}}
									 
									 <br/>
									 <span style="font-size:12px;text-transform:lowercase;color:#666">{{scope.row.member.person.email}}</span> 
								</span>	 
								<span v-if="scope.row.member.is_company==1"> 
							 		{{scope.row.member.shareholder_company.company_name}}  ({{scope.row.member.shareholder_company.company_reg_num}})
								</span>
							</div>
							
							
						</template>
					</el-table-column>
					<el-table-column label="Shareholding" property="mode" min-width=100>
						<template slot-scope="scope">
							<div v-if="scope.row.entity.company_type!=7">	{{scope.row.percentage}}% </div>
							<div v-if="scope.row.entity.company_type==7"> Member </div>
						</template>
					</el-table-column>
					
			
					
					<el-table-column label="Notification Sent" property="sent_to" min-width=140>
						<template slot-scope="scope">
							<div v-if="scope.row.compliance">
								<div v-if="scope.row.compliance.notification_status == 1"> 
									{{scope.row.compliance.last_notification_date_str}}
								</div>
								<div v-else> - </div>
							</div>
							

						</template>
					
					</el-table-column>
					<el-table-column  label="Submission Date"  min-width=140>
						<template slot-scope="scope">
							<div v-if="scope.row.compliance">
								<div v-if="scope.row.compliance.submission_status == 1"> 
									{{scope.row.compliance.submission_date_str}}
								</div>
								<div v-else> - </div>
							</div>
						
						</template>
					</el-table-column>
					
					
					<el-table-column label="Compliance Status"  sortable property="compliance.compliance_status" min-width=125>
						<template slot-scope="scope">
						
						
							<div v-if="scope.row.c_update">
								<div v-if="scope.row.c_update.update_compliance_status == 1"> 
									<span style="color:green;font-weight:bold">Complete</span>
								</div>
								<div v-else-if="scope.row.c_update.update_compliance_status == 2"> 
									<span style="color:red;font-weight:bold">Incomplete</span>
								</div>
								<div v-else>
									<span style="color:red;font-weight:bold">-</span>
								</div>
							</div>
							
							<div v-else-if="scope.row.compliance">
								<div v-if="scope.row.compliance.compliance_status == 1"> 
									<span style="color:green;font-weight:bold">Complete</span>
								</div>
								<div v-else-if="scope.row.compliance.compliance_status == 2"> 
									<span style="color:red;font-weight:bold">Incomplete</span>
								</div>
								<div v-else>
									<span style="color:red;font-weight:bold">-</span>
								</div>
							</div>
						
						</template>
					</el-table-column>
					
					<el-table-column label="Client's Change"  min-width=170>
						<template slot-scope="scope">
							<div v-if="scope.row.compliance">
								<div v-if="scope.row.compliance.form_obj" style="font-size:11px;">
								
									<div v-if="scope.row.compliance.form_obj.im_controller==1">
											<strong>Is Controller </strong>
									</div>
									<div v-else><strong>Declared he/she isn't the controller</strong></div>
									
									
									<div v-if="scope.row.compliance.form_obj.know_controller==1">
											<strong>Know Of Another Controller </strong>
									</div>
									
									
									
									<div v-if="scope.row.compliance.form_obj.first_name">
											First Name: {{scope.row.compliance.form_obj.first_name}}
									</div>
									<div v-if="scope.row.compliance.form_obj.last_name">
											Last Name: {{scope.row.compliance.form_obj.last_name}}
									</div>
									<div v-if="scope.row.compliance.form_obj.alias">
											Alias: {{scope.row.compliance.form_obj.alias}}
									</div>
									<div v-if="scope.row.compliance.form_obj.address">
											Address: {{scope.row.compliance.form_obj.address}}
									</div>
									<div v-if="scope.row.compliance.form_obj.nationality">
											Nationality: {{scope.row.compliance.form_obj.nationality}}
									</div>
									<div v-if="scope.row.compliance.form_obj.gov_id">
											Gov ID: {{scope.row.compliance.form_obj.gov_id}}
									</div>
									<div v-if="scope.row.compliance.form_obj.dob">
											Date Of Birth: {{scope.row.compliance.form_obj.dob}}
									</div>
									<div v-if="scope.row.compliance.form_obj.date_controller">
											Date Became Controller: {{scope.row.compliance.form_obj.date_controller}}
									</div>
									<div v-if="scope.row.compliance.form_obj.know_controller_info">
											Info Of Another Known Controller: {{scope.row.compliance.form_obj.know_controller_info}}
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					
					
					
					<el-table-column label="Action" property="mode" min-width=140>
						<template slot-scope="scope">
							
							 <p-button v-if="scope.row.entity.company_type!=7" type="warning"  @click="sendNotification('shareholder', scope.row.shareholder.id, scope.row.entity.id)" >
									
									Send Email
							</p-button>
							
							
							<p-button v-if="scope.row.entity.company_type==7 && scope.row.member.is_company!=1" type="warning"  @click="sendNotification('member', scope.row.member.id, scope.row.entity.id)" >
									
									Send Email
							</p-button>
							<p-button v-if="scope.row.entity.company_type==7 && scope.row.member.is_company==1" type="warning"  @click="sendNotification('member', scope.row.member.id, scope.row.entity.id)" >
									
									Send Email
							</p-button>
							
							
							
							<div style="margin-top:15px;">
							<p-button v-if="scope.row.entity.company_type!=7 && scope.row.shareholder.is_company!=1" type="info"  @click="goToComplianceUpdates(scope.row.shareholder.id, scope.row.entity.id)" >
									
									View Details
							</p-button> 
							
							<p-button v-if="scope.row.entity.company_type==7 && scope.row.member.is_company!=1" type="info"  @click="goToComplianceUpdates(scope.row.member.id, scope.row.entity.id)" >
									
									View Details
							</p-button> 
							
							
						
							
								<p-button v-if="scope.row.entity.company_type!=7 && scope.row.shareholder.is_company==1" type="info"  @click="goToComplianceUpdates(scope.row.shareholder.id, scope.row.entity.id)" >
									
									View Details
								</p-button> 
							
								<p-button v-if="scope.row.entity.company_type==7 && scope.row.member.is_company==1" type="info"  @click="goToComplianceUpdates(scope.row.member.id, scope.row.entity.id)" >
									
									View Details
								</p-button> 
							
							</div>
							
							
						</template>
					</el-table-column>
					
					
				</el-table>
				
				
				
          </div>
        </div>
        
        
    
   
  
  </div>
</template>
<script>
  import Vue from 'vue'
  
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import users from './users'
  
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
     
    
    data () {
      return {
      	controllers:[],
      	tableTd:'',

      
      }
    },
    mounted() {
    	  swal.showLoading();
     	  let uri = this.$base_url+'/api/v1/entities/get/compliance_overview';
		  ApiService.get(uri).then(response => {
		  		this.controllers = response.data.controllers;
		  		 swal.close();
		  
		  });
    },
    methods: {
     goToComplianceUpdates(shareholder_id, entity_id){
      	 this.$router.push( '/compliance-updates/'+ shareholder_id +'/entity/'+ entity_id)
      },
      sendNotification(type, object_id, entity_id){
      		let compliance_type = 1;
      		
      		swal.showLoading();
      		let uri = this.$base_url+'/api/v1/entities/send_compliance_form';
			ApiService.post(uri,{
      					'object_id': object_id,
      					'type': type,
      					'entity_id': entity_id,
      					'compliance_type': compliance_type
      				}).then(response => {
      					swal.close();
      					 
						swal({
						  title: 'Done.',
						  text: 'The email notification has been sent.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
								swal.close();
								
						})//end swal
			
			})



      
      },
      
    }
  }
</script>
<style lang="scss">
.el-table .sort-caret{
	border:8px solid transparent;
}

.el-table .sort-caret.ascending{
	top:-3px;
}
.el-table .sort-caret.descending{
	bottom:1px;
}


</style>
